<template>

<div>
    <b-row>
        <b-col md="6" class="my-1">
            <h3 class="text-themecolor">Onbekende documenten ({{ count }})</h3>
        </b-col>
        <b-col md="6" class="my-1">
            <div class="pull-right">
                <b-button v-b-tooltip.hover title="Documenten met minder dan 500 karakters worden op onverwerkbaar gezet" v-on:click="documentLess500Characters" class="mx-2"><i class="fas fa-align-left"></i> 500 karakters</b-button>
                <b-button v-b-tooltip.hover title="Opnieuw door regexprocess" v-on:click="retryDocumentsThroughOcr" class="mx-2"><i class="fas fa-share-square"></i> Regexproces</b-button>
                <b-button v-b-tooltip.hover title="Verversen" class="mx-2"  v-on:click="refreshTable"><i class="fas fa-sync-alt"></i></b-button>
                <b-button class="mx-2 disabled">Onverwerkbaar</b-button>
            </div>
        </b-col>
    </b-row>
    <b-row>
        <b-col md="12">
            <div class="card">
                <div class="card-body">
                    <!-- User Interface controls -->
                    <b-row>
                        <!-- TODO Filter van klanten maken -->
                        <b-col md="12" class="my-1">
                            <b-form-group class="mb-0">
                                <b-input-group>
                                    <b-form-input v-model="filters.search" :placeholder="$t('datatables.zoeken')" ref='search' />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <!-- User Interface controls -->
                    <!-- Main table element -->
                    <b-row>
                        <b-col md="12">
                            <b-table class="table-hover"
                                     show-empty
                                     :items="documentenProvider" 
                                     :empty-text='getEmptyText(count)'
                                     :fields="fields"
                                     :current-page="currentPage" 
                                     :per-page="perPage" 
                                     :filter="filters"
                                     @row-clicked="onRowClicked"
                                     ref="table">
                                     <template v-slot:table-busy>
                                        <PreLoader/>
                                     </template>
                                     <template  v-slot:cell(selected)="row">
                                        <b-form-group>
                                            <input type="checkbox" v-model="row.item.selected" />
                                        </b-form-group>
                                     </template>
                                     <template v-slot:cell(fileCreationTime)="data">{{ data.item.fileCreationTime | datetime }}</template>
                            </b-table>
                        </b-col>
                    </b-row>
                    <!-- Main table element -->

                    <!-- Pagination controls -->
                    <b-row>
                        <b-col md="12" lg="5">
                            <b-form-group label-cols :label="$t('datatables.perpagina')">
                                <b-form-select :options="pageOptions" v-model="perPage" />
                            </b-form-group>
                        </b-col>
                        <b-col md="12" lg="7">
                            <b-pagination :total-rows="count" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
                        </b-col>
                    </b-row>
                    <!-- Pagination controls -->
                </div>
            </div>
        </b-col>
    </b-row>
    
</div>
</template>

<script>
//Import store
import { mapGetters, mapActions } from 'vuex'
import PreLoader from '@/components/root/Preloader';
import { getEmptyText } from '@/views/root/GetMessageTextHelper';

export default {
    name: `document-index`,
    components: {PreLoader},
    data() {
        return {
            command: {},
            currentPage: 1,
            perPage: 50,
            pageOptions: [50, 100, 200],
            filters: {
                search: ''
            },
            count: -1
        }
    },
    computed: {
        fields() { 
            return [
                {
                    key: 'selected',
                    label: ''
                },
                {
                    key: 'documentId',
                    label: 'DocumentId',
                    sortable: true
                },
                {
                    key: 'klant.customerIdAndName',
                    label: 'Klant',
                    sortable: true
                },
                 {
                    key: 'administratie.bedrijfsnaam',
                    label: 'Administratie',
                },
                {
                    key: 'fileCreationTime',
                    label: 'Datum',
                    sortable: true
                }
            ]
        },
        ...mapGetters('fmmodule', ['documenten']),
    },
    methods: {
        ...mapActions('fmmodule', ['all','executeCommand']),
        onRowClicked(item) 
        {
            this.$router.push({ name: `documents:detail`, params: { documentId: item.id } });
        },
        documentLess500Characters()
        {
            var vm = this;
            vm.$swal ({
                title: `Actie uitvoeren`,
                text: `Weet u zeker dat u alle documenten met minder dan 500 karakters op onverwerkbaar gezet worden ?`,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: `Ja, uitvoeren`,
                cancelButtonText: this.$i18n.t('delete.neeannuleren')
            })
            .then((result) => {
                if (result.value) {
                    vm.executeCommand({resource: 'documenten/documentLess500Characters',})
                    .then((data) => {
                        vm.$swal("Er zijn " + data.nrOfDocuments + " documenten verwerkt");
                    })
                    .catch(() => {
                        vm.$swal("Er is iets verkeerd gegaan, probeer het opnieuw");
                    });
                    this.$refs.table.refresh();
                }
            })
        },
        retryDocumentsThroughOcr()
        {
            var vm = this;
            vm.$swal ({
                title: `Actie uitvoeren`,
                text: `Weet u zeker dat u alle documenten weer door het triggerproces wil halen ?`,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: `Ja, uitvoeren`,
                cancelButtonText: this.$i18n.t('delete.neeannuleren')
            })
            .then((result) => {
                if (result.value) {
                    vm.executeCommand({resource: 'documenten/retryDocumentsThroughOcr'})
                     .then((data) => {
                        vm.$swal("Er zijn " + data.nrOfDocuments + " documenten verwerkt");
                    }).catch(() => {
                        vm.$swal("Er is iets verkeerd gegaan, probeer het opnieuw");
                    });
                    this.$refs.table.refresh();
                }
            })           
        },
        refreshTable(){
            this.$refs.table.refresh();
        },
        documentenProvider(ctx, callback) {         
            var vm = this;
            vm.all({
                resource: 'documenten/onbekend',
                queryParameters: [
                    {key: '$top', value: ctx.perPage},
                    {key: '$skip', value: ctx.currentPage * ctx.perPage - ctx.perPage},
                    {key: '$count', value: true},

                ],
                cacheResult: false
            }).then((data) => {
                vm.count = data.metadata.count;
                callback(data.result);
            }).catch(() => {
                callback([]);
            });
            
        },
        getEmptyText,
    }
}

</script>
